// extracted by mini-css-extract-plugin
export default {"data_container":"AddLogModal_data_container__umz4P","property":"AddLogModal_property__kKA2v","value":"AddLogModal_value__tH-68"};